import { LOGIN, LOGOUT, REGISTRATION, REDIRECT, REDIRECT_TO, CREATE_LINK, REDEEM_COUPON, LOAD_PROJECT } from '../actions/actionTypes.js';

import queryString from 'query-string';

const initialState = {
  redirectTo: null
}

export const app = (state = initialState, action) => {
  const params = queryString.parse(window.location.search);
  const { slug } = params || {}
  const { noredirect, next } = action.payload || {} 
  
  
  switch (action.type) {
    // RedirectTo
    case REGISTRATION.SUCCESS:
    case LOGIN.SUCCESS:
    case LOGOUT:
    case REDEEM_COUPON.SUCCESS:
    case LOAD_PROJECT.SUCCESS:
      if (noredirect === true)
        return state;
      else if ( next && !slug)
        return {...state, redirectTo: next};
      else
        return {
          ...state,
          redirectTo: `/${slug ? '?slug='+slug : ''}`
        };
    case CREATE_LINK.SUCCESS:
      if (noredirect !== true && action.payload && !action.fromCable && action.payload.id && (action.payload.type === 'biolink' || action.payload.type === 'smartpage')){
        sessionStorage.removeItem('unsvd_pg_new');
        return {
          ...state,
          redirectTo: action.payload.type === 'smartpage' ? `/pages/${action.payload.id}` : `/biolinks/${action.payload.id}`
        }
      }
      else{
        return state
      }
    case REDIRECT_TO:
      return {
        ...state,
        redirectTo: action.payload
      }
    case '@@router/LOCATION_CHANGE':
    case REDIRECT:
      return {
        ...state,
        redirectTo: null
      };
    
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/app.js